import React from 'react';
import Button from '../../../../components/button/button';
import './submit-site-section.css';

const SubmitSiteSection = (props) => {
  const {
    confirmButton,
    description,
    onSubmitSiteConfirmButton,
  } = props;
  return (
    <div className="row">
      <div className="col-12 pl-sm-0">
        {description}
      </div>
      <div className="col-12 button-section pl-sm-0">
        <Button
          className="button do-business confirm-btn"
          buttonText={confirmButton}
          onClick={onSubmitSiteConfirmButton}
        />
      </div>
    </div>
  );
};

export default SubmitSiteSection;
